import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import { Link } from 'react-router-dom';

import examElementImg from '../../assets/img/cl-bg.png';
import notebookElementImg from '../../assets/img/notebook-element-bg.svg';
import { setOpenMaterialFlag } from '../../Common/Database';

const ShelfBlock = ({ items, mail, nameItem }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [width, setWidth] = useState(0);

  const onClickBook = subject => {
    let row = subject;
    if (!('materialOpen' in row) || !row.materialOpen) {
      setOpenMaterialFlag(mail, 'materials', row.id);
    }
    if (row) {
      navigate('/materialView', { state: row });
    }
  };

  const onClickExam = subject => {
    let row = subject;
    if (!('materialOpen' in row) || !row.materialOpen) {
      setOpenMaterialFlag(mail, 'materials', row.id);
    }
    if ('chapter' in row) {
      navigate(`/checklist-editor-student/${row.id}`, { state: row });
    } else {
      navigate('/materialView', { state: row });
    }
  };

  const isObject = value => {
    return Object.prototype.toString.call(value) === '[object Object]';
  };

  const cutNameOfExam = name => {
    const length = name.length;
    if (width >= 768 && length > 120) {
      return `${name.slice(0, 120)}...`;
    } else if (width < 768 && length > 40) {
      return `${name.slice(0, 40)}...`;
    }
    return name;
  };

  window.onresize = () => {
    const wid = window.innerWidth;
    setWidth(wid);
  };

  window.onload = () => {
    const wid = window.innerWidth;
    setWidth(wid);
  };

  useEffect(() => {
    const wid = window.innerWidth;
    setWidth(wid);
  }, [width]);

  return (
    <>
      <div className="shelf-block-item">
        {Array.isArray(items) &&
          items.map((item, key) => {
            <h2 key={key}>{item.itemName}</h2>;

            {
              if (
                nameItem == 'notebooks' ||
                nameItem == 'books' ||
                nameItem == 'exams' ||
                nameItem == 'exams-tab' ||
                nameItem == 'materials'
              ) {
                switch (item.itemName) {
                  case 'Book':
                    return (
                      <div className="shelf-block-book tooltipe-wrap">
                        <div className="tooltipe">{item.subject.name}</div>
                        <div key={key} className="shelf-block-book" onClick={() => onClickBook(item.subject)}>
                          <img src={item.subject.thum} alt={item.itemName} />
                        </div>
                      </div>
                    );
                  case 'notebook':
                    return (
                      <Link
                        key={key}
                        className="shelf-block-img"
                        to={`/notebook/${mail}/${params.subject ? params.subject : item.subject}`}
                      >
                        <img src={notebookElementImg} alt={item.itemName} />
                        <div className="text-notebook">
                          <div className="text-notebook-content">
                            {t('notebook-title')} {t(isObject(item.subject) ? params.subject : item.subject)}
                          </div>
                        </div>
                      </Link>
                    );
                  case 'Exam':
                    return (
                      <div className="shelf-block-img tooltipe-wrap">
                        <div className="tooltipe">{item.subject.name}</div>
                        <div key={key} className="shelf-block-img" onClick={() => onClickExam(item.subject)}>
                          <img src={examElementImg} alt={item.itemName} />
                          {item.subject.chapter && (
                            <span className="deadline">
                              {t('dead-line')}: {item.subject.deadline}
                            </span>
                          )}
                          <h3 className="name-top-subject">{t(item.subject.subject)}</h3>

                          <div className="text-exam">
                            <div className="text-exam-content">
                              <span>{cutNameOfExam(item.subject.name)}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    );

                  default:
                    break;
                }
              }

              if (item.nameItem === 'Book') {
                return (
                  <div className="shelf-block-book tooltipe-wrap">
                    <div className="tooltipe">{item.subject}</div>
                    <div key={key} className="shelf-block-book" onClick={() => onClickBook(item)}>
                      <img src={item.thum} alt={item.itemName} />
                    </div>
                  </div>
                );
              }

              if (item.nameItem === 'icl') {
                return (
                  <div className="shelf-block-img tooltipe-wrap">
                    <div className="tooltipe">{language === 'ua' ? item.subject.name : item.subject.ruName}</div>
                    <div
                      key={item.id}
                      className="shelf-block-img"
                      onClick={() => navigate('/checklist-student', { state: { checkListId: item.id } })}
                    >
                      <img src={examElementImg} alt={language === 'ua' ? item.subject.name : item.subject.ruName} />

                      <h3 className="name-top-subject">
                        {language === 'ua' ? item.subject.name : item.subject.ruName}
                      </h3>

                      <div className="text-exam">
                        <div className="text-exam-content">
                          <span>{cutNameOfExam(item.theme)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }

              if (item.nameItem === 'exam') {
                return (
                  <div className="shelf-block-img tooltipe-wrap">
                    <div className="tooltipe">{language === 'ua' ? item.subject.name : item.subject.ruName}</div>
                    <div
                      key={item.id}
                      className="shelf-block-img"
                      onClick={() => navigate('/exam-student', { state: { examId: item.id } })}
                    >
                      <img src={examElementImg} alt={language === 'ua' ? item.subject.name : item.subject.ruName} />

                      <h3 className="name-top-subject">
                        {language === 'ua' ? item.subject.name : item.subject.ruName}
                      </h3>

                      <div className="text-exam">
                        <div className="text-exam-content">
                          <span>{cutNameOfExam(item.theme)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }

              if (item.nameItem === 'hw') {
                return (
                  <div className="shelf-block-img tooltipe-wrap">
                    <div className="tooltipe">{language === 'ua' ? item.subject.name : item.subject.ruName}</div>
                    <div
                      key={item.id}
                      className="shelf-block-img"
                      onClick={() => navigate('/hw-student', { state: { hwId: item.id } })}
                    >
                      <img src={examElementImg} alt={language === 'ua' ? item.subject.name : item.subject.ruName} />

                      <h3 className="name-top-subject">
                        {language === 'ua' ? item.subject.name : item.subject.ruName}
                      </h3>

                      <div className="absolute bottom-2 left-2">
                        {item.checked && <div className="text-[11px] lg:text-[18px]">{t('checked')}</div>}

                        {item.completed && <div className="text-[11px] lg:text-[18px]">{t('completed')}</div>}
                      </div>

                      <div className="text-exam">
                        <div className="text-exam-content">
                          <span>{cutNameOfExam(item.title)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }
            }
          })}
      </div>
    </>
  );
};

export { ShelfBlock };
